// extracted by mini-css-extract-plugin
export default {"loading":"betterloading_loading__SKOSr","circle":"betterloading_circle__FDHxz","spinner-c7wet2":"betterloading_spinner-c7wet2__arIL-"};